import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ContactForm from './ContactForm';

/**
 * Contact Form Modal Component
 * Wraps the ContactForm in a dialog for use as a popup
 */
function ContactFormModal({ open, onClose, defaultCategory = '', initialValues, title = 'Contact Us', mcpOnly = false, inquiryPurpose }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isMobile}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : 3,
          backgroundColor: theme.chrome?.documentation ? theme.palette.background.paper : theme.palette.mode === 'dark'
            ? 'rgb(30, 35, 50)'
            : 'rgb(245, 245, 252)',
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          pb: 1,
        }}
      >
        <Typography variant="h6" color="primary" sx={{ fontWeight: 500 }}>
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          size="small"
          aria-label="close"
          sx={{ color: theme.palette.text.secondary }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 4 }}>
        <ContactForm defaultCategory={defaultCategory} initialValues={initialValues} onSuccess={onClose} inModal mcpOnly={mcpOnly} inquiryPurpose={inquiryPurpose} />
      </DialogContent>
    </Dialog>
  );
}

export default ContactFormModal;
